import { faPrint } from '@fortawesome/pro-light-svg-icons';

import { useLoading } from '@/hooks/use-loading.hook';
import { Button } from '@/components/ui/button/button.component';
import { getAppointmentPDF } from '@/hooks/fetch/appointment/get-appointment-pdf.service';

interface AppointmentOptionsDownloadProps {
  id: string;
}

export function AppointmentOptionButtonDownload({ id }: AppointmentOptionsDownloadProps) {
  const { startLoading, stopLoading, isLoading } = useLoading();

  const downloadPdf = async () => {
    startLoading();
    try {
      const blob = await getAppointmentPDF({ id });
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'GUIA.pdf';
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    } finally {
      stopLoading();
    }
  };

  return (
    <Button
      data-testid="button-download--appointment-options"
      isLoading={isLoading}
      disabled={isLoading}
      className="flex justify-start"
      startIcon={faPrint}
      variant="text"
      onClick={downloadPdf}
    >
      Baixar guia
    </Button>
  );
}
